import EventDetail from './EventDetail';
import EventList from './EventList';

const routes = [
  {
    path: '',
    element: <EventList />,
  },
  {
    path: ':id',
    element: <EventDetail />,
  },
];

export default routes;
export { EventDetail, EventList };
